module.exports = __webpack_public_path__ + "static/media/edit-thin-24.ca4fff8f.svg";